var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-container"},[_c(_setup.StreamContainer,{attrs:{"show-room-tool":_vm.showRoomTool}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }